<div class="p-4">
  <h1 class="popup-title">{{ data$.confirmationTitle | translate }}</h1>
  <div class="popup-intro">
    {{ data$.confirmationText | translate }}
  </div>
</div>
<div class="">
  <form novalidate>
    <div class="divider"></div>

    <div class="cta wcf-button d-flex justify-content-end p-4">
      <a *ngIf="data$.confirmationButtons.cancelButton" (click)="onCancel()" class="btn-link link-btn">{{
        data$.confirmationButtons.cancelButton.buttonLabel | translate
      }}</a>
      <button
        blocx-button
        *ngIf="data$.confirmationButtons.extraOptionButton"
        class="mr12"
        (click)="onExtraOptionClick()"
        [variant]="'outline-primary'"
        type="button"
      >
        {{ data$.confirmationButtons.extraOptionButton.buttonLabel | translate }}
      </button>
      <button
        blocx-button
        *ngIf="data$.confirmationButtons.confirmButton"
        (click)="onConfirm()"
        [variant]="'outline-primary'"
        type="button"
      >
        {{ data$.confirmationButtons.confirmButton.buttonLabel | translate }}
      </button>
    </div>
  </form>
</div>
